import { clearKey, readWithTTL, setJSON } from 'dashboard/helper/laisStorage';

const DEFAULT_TTL_SECONDS = 30 * 60;
const ANONYMOUS_FAVORITE_TTL_SECONDS = 24 * 60 * 60;

export const PENDING_INTENT_KEYS = {
  favorite: 'lais:pending_favorite',
  anonymousFavorite: 'lais:pending_favorite',
  alert: 'lais:pending_alert',
};

export const LEGACY_PENDING_INTENT_KEYS = {
  anonymousFavorite: 'lais:pendingFavorite',
};

export const savePendingIntent = (
  key,
  intent,
  { ttlSeconds = DEFAULT_TTL_SECONDS, scope = 'session' } = {}
) => {
  setJSON(key, intent, { scope, ttlSeconds });
  return intent;
};

export const saveAnonymousFavoriteIntent = intent =>
  savePendingIntent(PENDING_INTENT_KEYS.anonymousFavorite, intent, {
    scope: 'local',
    ttlSeconds: ANONYMOUS_FAVORITE_TTL_SECONDS,
  });

export const consumePendingIntent = (
  key,
  { scope = 'session', fallbackKeys = [] } = {}
) => {
  const keys = [key, ...fallbackKeys].filter(Boolean);
  let consumedIntent = null;

  keys.some(currentKey => {
    const intent = readWithTTL(currentKey, { scope, fallback: null });
    clearKey(currentKey, { scope });
    consumedIntent = intent;
    return Boolean(intent);
  });

  return consumedIntent;
};

export const clearPendingIntent = (key, { scope = 'session' } = {}) =>
  clearKey(key, { scope });

export const consumeAnonymousFavoriteIntent = () =>
  consumePendingIntent(PENDING_INTENT_KEYS.anonymousFavorite, {
    scope: 'local',
    fallbackKeys: [LEGACY_PENDING_INTENT_KEYS.anonymousFavorite],
  }) ||
  consumePendingIntent(PENDING_INTENT_KEYS.favorite, {
    scope: 'session',
  });
